import { TeamAbrvID, TeamAbrvType } from '../types/id.types';

export enum NFLConference {
  AFC = 'AFC', // American Football Conference
  NFC = 'NFC', // National Football Conference
}

export enum NFLDivision {
  AFCNorth = 'AFC North',
  AFCEast = 'AFC East',
  AFCSouth = 'AFC South',
  AFCWest = 'AFC West',
  NFCNorth = 'NFC North',
  NFCEast = 'NFC East',
  NFCSouth = 'NFC South',
  NFCWest = 'NFC West',
}

export const USStatesWithNFLTeams: string[] = [
  'Arizona',
  'Georgia',
  'Maryland',
  'New York',
  'North Carolina',
  'Illinois',
  'Ohio',
  'Texas',
  'Colorado',
  'Michigan',
  'Wisconsin',
  'Indiana',
  'Florida',
  'Missouri',
  'Nevada',
  'California',
  'Minnesota',
  'Massachusetts',
  'Louisiana',
  'New Jersey',
  'Pennsylvania',
  'Washington',
  'Tennessee',
];

export const TeamDivisionMap: { [key in TeamAbrvType]: string } = {
  ARI: 'NFC West',
  ATL: 'NFC South',
  BAL: 'AFC North',
  BUF: 'AFC East',
  CAR: 'NFC South',
  CHI: 'NFC North',
  CIN: 'AFC North',
  CLE: 'AFC North',
  DAL: 'NFC East',
  DEN: 'AFC West',
  DET: 'NFC North',
  GB: 'NFC North',
  HOU: 'AFC South',
  IND: 'AFC South',
  JAX: 'AFC South',
  KC: 'AFC West',
  LV: 'AFC West',
  LAC: 'AFC West',
  LAR: 'NFC West',
  MIA: 'AFC East',
  MIN: 'NFC North',
  NE: 'AFC East',
  NO: 'NFC South',
  NYG: 'NFC East',
  NYJ: 'AFC East',
  PIT: 'AFC North',
  PHI: 'NFC East',
  SF: 'NFC West',
  SEA: 'NFC West',
  TB: 'NFC South',
  TEN: 'AFC South',
  WSH: 'NFC East',
};

export const TeamConferenceMap: { [key in TeamAbrvType]: string } = {
  BAL: 'AFC',
  BUF: 'AFC',
  CIN: 'AFC',
  CLE: 'AFC',
  DEN: 'AFC',
  HOU: 'AFC',
  IND: 'AFC',
  JAX: 'AFC',
  KC: 'AFC',
  LAC: 'AFC',
  LV: 'AFC',
  MIA: 'AFC',
  NE: 'AFC',
  NYJ: 'AFC',
  PIT: 'AFC',
  TEN: 'AFC',
  ARI: 'NFC',
  ATL: 'NFC',
  CAR: 'NFC',
  CHI: 'NFC',
  DAL: 'NFC',
  DET: 'NFC',
  GB: 'NFC',
  LAR: 'NFC',
  MIN: 'NFC',
  NO: 'NFC',
  NYG: 'NFC',
  PHI: 'NFC',
  SEA: 'NFC',
  SF: 'NFC',
  TB: 'NFC',
  WSH: 'NFC',
};

export const TeamNamesByID: string[] = [
  'All',
  'ARI',
  'ATL',
  'BAL',
  'BUF',
  'CAR',
  'CHI',
  'CIN',
  'CLE',
  'DAL',
  'DEN',
  'DET',
  'GB',
  'HOU',
  'IND',
  'JAX',
  'KC',
  'LV',
  'LAC',
  'LAR',
  'MIA',
  'MIN',
  'NE',
  'NO',
  'NYG',
  'NYJ',
  'PIT',
  'PHI',
  'SF',
  'SEA',
  'TB',
  'TEN',
  'WSH',
];

export const TID_LIST = [
  '0001-ARI',
  '0002-ATL',
  '0003-BAL',
  '0004-BUF',
  '0005-CAR',
  '0006-CHI',
  '0007-CIN',
  '0008-CLE',
  '0009-DAL',
  '0010-DEN',
  '0011-DET',
  '0012-GB',
  '0013-HOU',
  '0014-IND',
  '0015-JAX',
  '0016-KC',
  '0017-LV',
  '0018-LAC',
  '0019-LAR',
  '0020-MIA',
  '0021-MIN',
  '0022-NE',
  '0023-NO',
  '0024-NYG',
  '0025-NYJ',
  '0026-PIT',
  '0027-PHI',
  '0028-SF',
  '0029-SEA',
  '0030-TB',
  '0031-TEN',
  '0032-WSH',
] as const;

export enum TeamIDToTeamAbrv {
  teamID_01 = 'ARI',
  teamID_02 = 'ATL',
  teamID_03 = 'BAL',
  teamID_04 = 'BUF',
  teamID_05 = 'CAR',
  teamID_06 = 'CHI',
  teamID_07 = 'CIN',
  teamID_08 = 'CLE',
  teamID_09 = 'DAL',
  teamID_10 = 'DEN',
  teamID_11 = 'DET',
  teamID_12 = 'GB ',
  teamID_13 = 'HOU',
  teamID_14 = 'IND',
  teamID_15 = 'JAX',
  teamID_16 = 'KC ',
  teamID_17 = 'LV ',
  teamID_18 = 'LAC',
  teamID_19 = 'LAR',
  teamID_20 = 'MIA',
  teamID_21 = 'MIN',
  teamID_22 = 'NE ',
  teamID_23 = 'NO ',
  teamID_24 = 'NYG',
  teamID_25 = 'NYJ',
  teamID_26 = 'PIT',
  teamID_27 = 'PHI',
  teamID_28 = 'SF ',
  teamID_29 = 'SEA',
  teamID_30 = 'TB ',
  teamID_31 = 'TEN',
  teamID_32 = 'WHH',
}

export enum TeamAbrvToTeamID {
  ARI = '1',
  ATL = '2',
  BAL = '3',
  BUF = '4',
  CAR = '5',
  CHI = '6',
  CIN = '7',
  CLE = '8',
  DAL = '9',
  DEN = '10',
  DET = '11',
  GB = '12',
  HOU = '13',
  IND = '14',
  JAX = '15',
  KC = '16',
  LV = '17',
  LAC = '18',
  LAR = '19',
  MIA = '20',
  MIN = '21',
  NE = '22',
  NO = '23',
  NYG = '24',
  NYJ = '25',
  PIT = '26',
  PHI = '27',
  SF = '28',
  SEA = '29',
  TB = '30',
  TEN = '31',
  WSH = '32',
}
// #endregion

export const TeamColor = {
  [TeamAbrvToTeamID.ARI]: '#97233F',
  [TeamAbrvToTeamID.ATL]: '#A71930',
  [TeamAbrvToTeamID.BAL]: '#241773',
  [TeamAbrvToTeamID.BUF]: '#00338D',
  [TeamAbrvToTeamID.CAR]: '#0085CA',
  [TeamAbrvToTeamID.CHI]: '#0B162A',
  [TeamAbrvToTeamID.CIN]: '#FB4F14',
  [TeamAbrvToTeamID.CLE]: '#311D00',
  [TeamAbrvToTeamID.DAL]: '#041E42',
  [TeamAbrvToTeamID.DEN]: '#002244',
  [TeamAbrvToTeamID.DET]: '#0076B6',
  [TeamAbrvToTeamID.GB]: '#203731',
  [TeamAbrvToTeamID.HOU]: '#03202F',
  [TeamAbrvToTeamID.IND]: '#002C5F',
  [TeamAbrvToTeamID.JAX]: '#006778',
  [TeamAbrvToTeamID.KC]: '#E31837',
  [TeamAbrvToTeamID.LAC]: '#0080C6',
  [TeamAbrvToTeamID.LAR]: '#003594',
  [TeamAbrvToTeamID.LV]: '#000000',
  [TeamAbrvToTeamID.MIA]: '#008E97',
  [TeamAbrvToTeamID.MIN]: '#4F2683',
  [TeamAbrvToTeamID.NE]: '#002244',
  [TeamAbrvToTeamID.NO]: '#D3BC8D',
  [TeamAbrvToTeamID.NYG]: '#0B2265',
  [TeamAbrvToTeamID.NYJ]: '#125740',
  [TeamAbrvToTeamID.PHI]: '#004C54',
  [TeamAbrvToTeamID.PIT]: '#FFB612',
  [TeamAbrvToTeamID.SEA]: '#002244',
  [TeamAbrvToTeamID.SF]: '#AA0000',
  [TeamAbrvToTeamID.TB]: '#D50A0A',
  [TeamAbrvToTeamID.TEN]: '#4B92DB',
  [TeamAbrvToTeamID.WSH]: '#773141',
};

export const TeamSecondaryColor = {
  [TeamAbrvToTeamID.ARI]: '#000000',
  [TeamAbrvToTeamID.ATL]: '#A5ACAF',
  [TeamAbrvToTeamID.BAL]: '#9E7C0C',
  [TeamAbrvToTeamID.BUF]: '#C60C30',
  [TeamAbrvToTeamID.CAR]: '#101820',
  [TeamAbrvToTeamID.CHI]: '#C83803',
  [TeamAbrvToTeamID.CIN]: '#000000',
  [TeamAbrvToTeamID.CLE]: '#FF3C00',
  [TeamAbrvToTeamID.DAL]: '#869397',
  [TeamAbrvToTeamID.DEN]: '#FB4F14',
  [TeamAbrvToTeamID.DET]: '#B0B7BC',
  [TeamAbrvToTeamID.GB]: '#FFB612',
  [TeamAbrvToTeamID.HOU]: '#A71930',
  [TeamAbrvToTeamID.IND]: '#A5ACAF',
  [TeamAbrvToTeamID.JAX]: '#D7A22A',
  [TeamAbrvToTeamID.KC]: '#FFB81C',
  [TeamAbrvToTeamID.LAC]: '#FFC20E',
  [TeamAbrvToTeamID.LAR]: '#FFA300',
  [TeamAbrvToTeamID.LV]: '#A5ACAF',
  [TeamAbrvToTeamID.MIA]: '#FC4C02',
  [TeamAbrvToTeamID.MIN]: '#FFC62F',
  [TeamAbrvToTeamID.NE]: '#C60C30',
  [TeamAbrvToTeamID.NO]: '#101820',
  [TeamAbrvToTeamID.NYG]: '#A71930',
  [TeamAbrvToTeamID.NYJ]: '#000000',
  [TeamAbrvToTeamID.PHI]: '#A5ACAF',
  [TeamAbrvToTeamID.PIT]: '#101820',
  [TeamAbrvToTeamID.SEA]: '#69BE28',
  [TeamAbrvToTeamID.SF]: '#B3995D',
  [TeamAbrvToTeamID.TB]: '#FF7900',
  [TeamAbrvToTeamID.TEN]: '#0C2340',
  [TeamAbrvToTeamID.WSH]: '#FFB612',
};

export const TeamRivalries: Record<TeamAbrvID, TeamAbrvID[]> = {
  ['01-ARI']: ['06-CHI', '19-LAR', '28-SF', '29-SEA'],
  ['02-ATL']: ['05-CAR', '30-TB', '23-NO'],
  ['03-BAL']: ['07-CIN', '08-CLE', '22-NE', '26-PIT', '31-TEN', '32-WSH'],
  ['04-BUF']: ['16-KC', '20-MIA', '22-NE', '25-NYJ', '31-TEN'],
  ['05-CAR']: ['02-ATL', '23-NO', '30-TB'],
  ['06-CHI']: ['01-ARI', '11-DET', '12-GB', '21-MIN', '24-NYG'],
  ['07-CIN']: ['03-BAL', '08-CLE', '26-PIT'],
  ['08-CLE']: ['03-BAL', '07-CIN', '26-PIT'],
  ['09-DAL']: ['12-GB', '13-HOU', '21-MIN', '24-NYG', '26-PIT', '27-PHI', '28-SF', '32-WSH'],
  ['10-DEN']: ['16-KC', '17-LV', '18-LAC', '22-NE', '29-SEA'],
  ['11-DET']: ['06-CHI', '12-GB', '21-MIN'],
  ['12-GB']: ['06-CHI', '09-DAL', '11-DET', '21-MIN', '28-SF', '29-SEA', '30-TB'],
  ['13-HOU']: ['09-DAL', '14-IND', '15-JAX', '31-TEN'],
  ['14-IND']: ['13-HOU', '15-JAX', '22-NE', '31-TEN'],
  ['15-JAX']: ['13-HOU', '14-IND', '31-TEN'],
  ['16-KC']: ['04-BUF', '10-DEN', '17-LV', '18-LAC', '19-LAR'],
  ['17-LV']: ['10-DEN', '16-KC', '20-MIA', '26-PIT', '28-SF', '29-SEA'],
  ['18-LAC']: ['10-DEN', '16-KC', '19-LAR'],
  ['19-LAR']: ['01-ARI', '16-KC', '18-LAC', '21-MIN', '23-NO', '28-SF', '29-SEA'],
  ['20-MIA']: ['04-BUF', '17-LV', '22-NE', '25-NYJ', '30-TB'],
  ['21-MIN']: ['06-CHI', '09-DAL', '11-DET', '12-GB', '19-LAR'],
  ['22-NE']: ['03-BAL', '04-BUF', '10-DEN', '14-IND', '20-MIA', '24-NYG', '25-NYJ', '26-PIT'],
  ['23-NO']: ['02-ATL', '05-CAR', '19-LAR', '30-TB'],
  ['24-NYG']: ['06-CHI', '09-DAL', '22-NE', '25-NYJ', '27-PHI', '28-SF', '32-WSH'],
  ['25-NYJ']: ['04-BUF', '20-MIA', '22-NE', '24-NYG'],
  ['26-PIT']: ['03-BAL', '07-CIN', '08-CLE', '09-DAL', '17-LV', '22-NE', '27-PHI', '31-TEN'],
  ['27-PHI']: ['09-DAL', '24-NYG', '26-PIT', '32-WSH'],
  ['28-SF']: ['01-ARI', '09-DAL', '12-GB', '17-LV', '19-LAR', '24-NYG', '29-SEA'],
  ['29-SEA']: ['01-ARI', '10-DEN', '12-GB', '17-LV', '19-LAR', '28-SF'],
  ['30-TB']: ['02-ATL', '05-CAR', '12-GB', '20-MIA', '23-NO'],
  ['31-TEN']: ['03-BAL', '04-BUF', '13-HOU', '14-IND', '15-JAX', '26-PIT'],
  ['32-WSH']: ['09-DAL', '03-BAL', '24-NYG', '27-PHI'],
};
